<!-- MODULO IMG WIDE -->
<div class="container mb-5 modulo modulo-img-wide">
  <div class="row">
    <div class="col-12">
      <img *ngIf="campi.IMMAGINE?.valore" [appSrcDesktopLandscape169]="campi.IMMAGINE?.valore?.path" [alt]="campi.IMMAGINE.valore.alt" class="img-fluid mx-auto d-block">
    </div>
  </div>
</div>
<!-- //MODULO IMG WIDE -->